import { atom } from 'jotai';

export const appUserAtom = atom<AppUser | null>(null);
